import { FAMILY_ACQUA, FAMILY_CABINA_HAMMAM, FAMILY_GENERATORE_VAPORE, FAMILY_PORTE, FAMILY_SAUNA, FAMILY_SISTEMA_INTEGRATO } from "./listFamilies"

const ALADDIN = "aladdin"
const AQUASTEAM = "aquasteam"
const AQUASTEAM_SMART = "aquasteam_smart"
const BODYLOVE_H = "bodylove_h"
const BODYLOVE_S = "bodylove_s"
const BODYLOVE_SH = "bodylove_sh"
const CABANON = "cabanon"
const EASYSTEAM = "easysteam"
const EASYSTEAM_SMART = "easysteam_smart"
// const H = "h" @deprecated
const INSIDE = "inside"
const LOGICA_H = "logica_h"
// const LOGICA_MID = "logica_mid" @deprecated
const LOGICA_S = "logica_s"
const LOGICA_SH = "logica_sh"
const LOGICA_SPA = "logica_spa"
const MID = "mid"
const NATURAL_INFRARED = "natural_infrared"
const NATURAL_SAUNA = "natural_sauna"
const NATURAL_HAMMAM = "natural_hammam"
const NUVOLA_SMART = "nuvola_smart"
const NUVOLA_SMART_POWER = "nuvola_smart_power"
const NUVOLA = "nuvola"
const ONE_H = "one_h"
const ONE_S = "one_s"
// const SAUNA = "sauna" @deprecated
const SAUNA_BIOSAUNA = "sauna_biosauna"
const AIR = "air"
const AUKI = "auki"
const IDEA = "idea"
const IDEA_IR = "idea_ir"
const SKY = "sky"
// const SKY_CORNER = "sky_corner" @deprecated
const TOUCH_STEAM = "touch_steam"
const TOUCH_STEAM_SMART = "touch_steam_smart"
const WATERDREAM = "waterdream"
const WATERSUITE = "watersuite"
const YOKU_S = "yoku_s"
const YOKU_H = "yoku_h"
const YOKU_SH = "yoku_sh"
const YOKU_SPA = "yoku_spa"
// Added after task "Miglioramento Richiesta Assistenza con gestione 'porte'" of Francesco Fabbri.
const KANSO = "kanso"
const EASY = "easy"
const SAUNA_SU_MISURA = "sauna_su_misura"
const H_SMALL = "h_small"
const H_MEDIUM = "h_medium"
const H_LARGE = "h_large"
const HAMMAM_SU_MISURA = "hamma_su_misura"
const IR_SU_MISURA = "ir_su_misura"
const LOGICA_PLUS_SH = "logica_plus_sh"
const LOGICA_PLUS_MID = "logica_plus_mid"
const LOGICA_PLUS_SPA = "logica_plus_spa"
const SISTEMA_INTEGRATO_SU_MISURA = "sistema_integrato_su_misura"
const PORTA_ADAPTA = "porta_adapta";
const PORTA_SPAZIOSLIDE = "porta_spazioslide";
const PORTA_SPAZIOFILO = "porta_spaziofilo";
const PORTA_SPAZIO = "porta_spazio";
const PORTA_TUTTOVETRO_INSIDE = "porta_tuttovetro_inside";
const PORTA_TUTTOVETRO_CONTOUR = "porta_tuttovetro_contour";
const PORTA_FIT = "porta_fit";
const PORTA_CUSTOM = "porta_custom";
export const SENSORY_SHOWER = "sensory_shower";
export const FIT_SHOWER = "fit_shower";
export const TUBO_KNEIP = "tubo_kneip";
export const FEEL_GOOD_SHOWER = "feel_good_shower";
export const BUCKET_SHOWER = "bucket_shower";
const DOCCIA_CUSTOM = "doccia_custom";


export default [
  // Saune
  { value: BODYLOVE_S, label: "BodyLove S", family: FAMILY_SAUNA, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/BodyLove+S.png" },
  { value: YOKU_S, label: "Yoku S", family: FAMILY_SAUNA, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Yoku+S.png" },
  { value: NATURAL_SAUNA, label: "Natural S", family: FAMILY_SAUNA, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Natural+S%402x.png" },
  { value: ALADDIN, label: "Aladdin", family: FAMILY_SAUNA, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Aladdin%402x.png" },
  { value: AIR, label: "Air", family: FAMILY_SAUNA, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Suana+-+Bionasauna.png" },
  { value: SKY, label: "Sky", family: FAMILY_SAUNA, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Suana+-+Bionasauna.png" },
  { value: KANSO, label: "Kanso", family: FAMILY_SAUNA, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/large-Suana+-+Bionasauna(2).png" },
  { value: AUKI, label: "Auki", family: FAMILY_SAUNA, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Suana+-+Bionasauna.png" },
  { value: IDEA, label: "Idea", family: FAMILY_SAUNA, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Suana+-+Bionasauna.png" },
  { value: LOGICA_S, label: "Logica S", family: FAMILY_SAUNA, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Logica+S.png" },
  { value: ONE_S, label: "One S", family: FAMILY_SAUNA, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/One+S.png" },
  { value: EASY, label: "Easy", family: FAMILY_SAUNA, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/large-Suana+-+Bionasauna(2).png" },
  { value: CABANON, label: "Cabanon", family: FAMILY_SAUNA, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Cabanon.png" },
  { value: SAUNA_BIOSAUNA, label: "Biosauna", family: FAMILY_SAUNA, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Suana+-+Bionasauna.png" },
  { value: SAUNA_SU_MISURA, label: "Custom", family: FAMILY_SAUNA, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Suana+-+Bionasauna.png" },

  // Hammam
  { value: BODYLOVE_H, label: "BodyLove H", family: FAMILY_CABINA_HAMMAM, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/BodyLove+H.png" },
  { value: YOKU_H, label: "Yoku H", family: FAMILY_CABINA_HAMMAM, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Yoku+H.png" },
  { value: NATURAL_HAMMAM, label: "Natural H", family: FAMILY_CABINA_HAMMAM, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Natural+H%402x.png" },
  { value: ONE_H, label: "One H", family: FAMILY_CABINA_HAMMAM, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/One++H.png" },
  { value: H_SMALL, label: "H Small", family: FAMILY_CABINA_HAMMAM, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/H.png" },
  { value: H_MEDIUM, label: "H Medium", family: FAMILY_CABINA_HAMMAM, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/H.png" },
  { value: H_LARGE, label: "H Large", family: FAMILY_CABINA_HAMMAM, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/H.png" },
  { value: LOGICA_H, label: "Logica H", family: FAMILY_CABINA_HAMMAM, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Logica+H.png" },
  { value: HAMMAM_SU_MISURA, label: "Custom", family: FAMILY_CABINA_HAMMAM, img: null },

  // Cabine IR
  { value: NATURAL_INFRARED, label: "Natural IR", family: FAMILY_CABINA_HAMMAM, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Natural+IR%402x.png" },
  { value: IDEA_IR, label: "Idea IR", family: FAMILY_CABINA_HAMMAM, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Suana+-+Bionasauna.png" },
  { value: IR_SU_MISURA, label: "Custom", family: FAMILY_CABINA_HAMMAM, img: null },

  //Generatore di Vapore
  { value: AQUASTEAM, label: "AquaSteam", family: FAMILY_GENERATORE_VAPORE, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/AcquaSteam.png" },
  { value: AQUASTEAM_SMART, label: "AquaSteam Smart", family: FAMILY_GENERATORE_VAPORE, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/AcquaSteam.png" },
  { value: EASYSTEAM, label: "Easysteam", family: FAMILY_GENERATORE_VAPORE, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/EasySteam+Smart.png" },
  { value: EASYSTEAM_SMART, label: "Easysteam Smart", family: FAMILY_GENERATORE_VAPORE, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/EasySteam+Smart.png" },
  { value: TOUCH_STEAM, label: "Touch&Steam", family: FAMILY_GENERATORE_VAPORE, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Touch_Steam.png" },
  { value: TOUCH_STEAM_SMART, label: "Touch&Steam Smart", family: FAMILY_GENERATORE_VAPORE, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Touch_Steam.png" },
  { value: INSIDE, label: "Inside", family: FAMILY_GENERATORE_VAPORE, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Inside.png" },
  { value: NUVOLA, label: "Nuvola", family: FAMILY_GENERATORE_VAPORE, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Nuvola.png" },
  { value: NUVOLA_SMART_POWER, label: "Nuvola Smart Power", family: FAMILY_GENERATORE_VAPORE, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Nuvola+Smart.png" },
  { value: NUVOLA_SMART, label: "Nuvola Smart", family: FAMILY_GENERATORE_VAPORE, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Nuvola+Smart+0.png" },

  // Sistema integrato
  { value: BODYLOVE_SH, label: "BodyLove SH", family: FAMILY_SISTEMA_INTEGRATO, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/BodyLove+SH.png" },
  { value: LOGICA_PLUS_SPA, label: "Logica Plus SPA", family: FAMILY_SISTEMA_INTEGRATO, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Logica+SPA.png" },
  { value: LOGICA_PLUS_SH, label: "Logica Plus SH", family: FAMILY_SISTEMA_INTEGRATO, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Logica+SH.png" },
  { value: LOGICA_PLUS_MID, label: "Logica Plus Mid", family: FAMILY_SISTEMA_INTEGRATO, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Logica+Mid.png" },
  { value: LOGICA_SPA, label: "Logica SPA", family: FAMILY_SISTEMA_INTEGRATO, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Logica+SPA.png" },
  { value: LOGICA_SH, label: "Logica SH", family: FAMILY_SISTEMA_INTEGRATO, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Logica+SH.png" },
  { value: MID, label: "Mid", family: FAMILY_SISTEMA_INTEGRATO, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Mid.png" },
  { value: YOKU_SPA, label: "Yoku SPA", family: FAMILY_SISTEMA_INTEGRATO, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Yoku+Spa.png" },
  { value: YOKU_SH, label: "Yoku SH", family: FAMILY_SISTEMA_INTEGRATO, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Yoku+SH.png" },
  { value: SISTEMA_INTEGRATO_SU_MISURA, label: "Custom", family: FAMILY_SISTEMA_INTEGRATO, img: null },

  // PORTA
  { value: PORTA_ADAPTA, label: "Adapta", family: FAMILY_PORTE, img: null },
  { value: PORTA_SPAZIOSLIDE, label: "Spazioslide", family: FAMILY_PORTE, img: null },
  { value: PORTA_SPAZIOFILO, label: "Spaziofilo", family: FAMILY_PORTE, img: null },
  { value: PORTA_SPAZIO, label: "Spazio", family: FAMILY_PORTE, img: null },
  { value: PORTA_TUTTOVETRO_INSIDE, label: "Tuttovetro Inside", family: FAMILY_PORTE, img: null },
  { value: PORTA_TUTTOVETRO_CONTOUR, label: "Tuttovetro Contour", family: FAMILY_PORTE, img: null },
  { value: PORTA_FIT, label: "Fit", family: FAMILY_PORTE, img: null },
  { value: PORTA_CUSTOM, label: "Custom", family: FAMILY_PORTE, img: null },

  // MINIPISCINE E VASCHE
  { value: WATERDREAM, label: "WaterDream", family: FAMILY_ACQUA, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Waterdream.png" },
  { value: WATERSUITE, label: "WaterSuite", family: FAMILY_ACQUA, img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/WaterSuite.png" },

  // DOCCE
  { value: SENSORY_SHOWER, label: "Sensory Shower", family: FAMILY_ACQUA, img: null },
  { value: FIT_SHOWER, label: "Fit Shower", family: FAMILY_ACQUA, img: null },
  { value: TUBO_KNEIP, label: "Tubo Kneip", family: FAMILY_ACQUA, img: null },
  { value: FEEL_GOOD_SHOWER, label: "Feel Good Shower", family: FAMILY_ACQUA, img: null },
  { value: BUCKET_SHOWER, label: "Bucket Shower", family: FAMILY_ACQUA, img: null },
  { value: DOCCIA_CUSTOM, label: "Custom", family: FAMILY_ACQUA, img: null },

  // { value: H, label: "H", img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/H.png" },
  // { value: SAUNA, label: "Sauna (custom size)", img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Suana+-+Bionasauna.png" },
  // { value: SKY_CORNER, label: "Sky Corner", img: "https://form-effe-assistenza-ticket.s3.eu-central-1.amazonaws.com/Suana+-+Bionasauna.png" },

]
